import { useApp } from "../lib/store";

const ROT = { 1: 0, 2: 180, 3: 90, 4: 270, 5: 0, 6: 180, 7: 90, 8: 270 };

export function WindingSvg({ dir, className = "w-full h-12" }) {
  const outside = dir <= 4;
  const webY = outside ? 8 : 36;
  const rot = ROT[dir] || 0;
  return (
    <svg viewBox="0 0 66 44" className={className}>
      <circle cx="17" cy="22" r="13" fill="none" stroke="#1B2A4A" strokeWidth="2" />
      <circle cx="17" cy="22" r="4.5" fill="#e5e7eb" stroke="#9ca3af" strokeWidth="1" />
      <line x1="17" y1={webY} x2="62" y2={webY} stroke="#1B2A4A" strokeWidth="2" />
      <rect x="40" y={webY - 7} width="15" height="14" rx="1.5" fill="#fff" stroke="#F5A623" strokeWidth="1.5" />
      <text x="47.5" y={webY + 3.5} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1B2A4A"
        transform={`rotate(${rot} 47.5 ${webY})`}>A</text>
      <path d={`M 58 ${webY - 4} l 4 4 l -4 4`} fill="none" stroke="#9ca3af" strokeWidth="1.5" />
    </svg>
  );
}

export function WindingPicker({ value, onChange, disabled }) {
  const { t } = useApp();
  return (
    <div data-testid="winding-picker">
      <div className="grid grid-cols-4 gap-2">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((d) => (
          <button key={d} type="button" disabled={disabled} data-testid={`winding-option-${d}`}
            onClick={() => onChange?.(d)}
            className={`rounded-lg border-2 p-1.5 transition-colors duration-150 ${
              Number(value) === d ? "border-[#F5A623] bg-amber-50" : "border-gray-200 hover:border-gray-300 bg-white"}`}>
            <WindingSvg dir={d} />
            <div className="text-[11px] font-semibold text-center text-gray-700 mt-0.5">{d}</div>
          </button>
        ))}
      </div>
      <div className="flex justify-between text-[10px] uppercase tracking-widest text-gray-400 mt-1.5 px-1">
        <span>1–4: {t("winding_outside")}</span>
        <span>5–8: {t("winding_inside")}</span>
      </div>
    </div>
  );
}
